/**
 * https://developer.mozilla.org/en-US/docs/Web/HTTP/Browser_detection_using_the_user_agent#avoiding_user_agent_detection
 * Mobile device detection
 */

type NavigatorType = Omit<Navigator, 'maxTouchPoints'> & {
  maxTouchPoints?: Navigator['maxTouchPoints'];
  msMaxTouchPoints?: Navigator['maxTouchPoints'];
};

const isWithMsMaxTouchPoints = (
  navigator: NavigatorType,
): navigator is Navigator & { msMaxTouchPoints: number } =>
  'msMaxTouchPoints' in navigator;

export function detectMobileDevice(): boolean {
  let hasTouchScreen = false;
  const { navigator } = window as { navigator: NavigatorType };
  if ('maxTouchPoints' in navigator) {
    hasTouchScreen = navigator.maxTouchPoints! > 0;
  } else if (isWithMsMaxTouchPoints(navigator)) {
    hasTouchScreen = navigator.msMaxTouchPoints > 0;
  } else {
    const mQ = window.matchMedia && matchMedia('(pointer:coarse)');
    if (mQ && mQ.media === '(pointer:coarse)') {
      hasTouchScreen = !!mQ.matches;
    } else if ('orientation' in window) {
      hasTouchScreen = true; // deprecated, but good fallback
    } else {
      // Only as a last resort, fall back to user agent sniffing
      const UA = navigator.userAgent;
      hasTouchScreen =
        /\b(BlackBerry|webOS|iPhone|IEMobile)\b/i.test(UA) ||
        /\b(Android|Windows Phone|iPad|iPod)\b/i.test(UA);
    }
  }

  return hasTouchScreen;
}

export const detectIOSDevice = () => 
  /**
   * navigator.platform should not be marked as deprecated.
   * https://github.com/microsoft/TypeScript/issues/49683
   * */
   /iPad|iPhone|iPod/.test(navigator.platform)
;
